// extracted by mini-css-extract-plugin
module.exports = {"bb-soundcloud-with-cookie":"bb-soundcloud-with-cookie__Fkl_a"};